import InertIcon from "./InertIcon";
import ConversationList from "./ConversationList";
import { resolveDemoIcon } from "../icons/defaultIcons";
import type { Conversation, InboxDemoIcons } from "../data/types";
import type { RefObject } from "react";

type ConversationPanelProps = {
  conversations: Conversation[];
  selectedConversationId: string;
  icons: InboxDemoIcons;
  listRef: RefObject<HTMLDivElement | null>;
  title?: string;
  onSelect: (conversationId: string) => void;
  onUserIntent: () => void;
};

export default function ConversationPanel({
  conversations,
  selectedConversationId,
  icons,
  listRef,
  title = "📬 全部消息",
  onSelect,
  onUserIntent,
}: ConversationPanelProps) {
  return (
    <section className="flex h-full min-w-0 flex-1 flex-col overflow-hidden px-3 md:min-w-[220px] md:px-4">
      <div className="flex items-center gap-2 bg-content1 py-4">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <p className="truncate text-base font-medium leading-6 text-default-foreground">
            {title}
          </p>
          <InertIcon className="text-default-400">
            {resolveDemoIcon(icons, "chevronDown")}
          </InertIcon>
        </div>
        <InertIcon className="flex size-5 items-center justify-center rounded-xl text-default-500">
          {resolveDemoIcon(icons, "listSearch")}
        </InertIcon>
      </div>
      <ConversationList
        conversations={conversations}
        icons={icons}
        listRef={listRef}
        selectedConversationId={selectedConversationId}
        onSelect={onSelect}
        onUserIntent={onUserIntent}
      />
    </section>
  );
}
